/**
 * Alpine newsletter store + popup controller.
 * Opened from the info-page signup link, and in the theme editor.
 * Must load before alpine.min.js.
 */

// Retire the timed first-visit popup: its dismissal cookie and the splash
// timestamp that delayed the automatic open.
document.cookie = "vague_newsletter_dismissed=; Max-Age=0; Path=/; SameSite=Lax";
try {
  sessionStorage.removeItem("vague-splash-dismissed-at");
} catch (error) {}

document.addEventListener("alpine:init", () => {
  function newsletterDialog() {
    return document.getElementById("newsletter-popup");
  }

  function syncNewsletterDialog(open) {
    const dialog = newsletterDialog();
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }

  Alpine.store("newsletter", {
    open: false,

    show() {
      this.open = true;
      // After the opening click, so that click is not treated as an
      // outside click that immediately dismisses the dialog.
      requestAnimationFrame(() => syncNewsletterDialog(true));
    },

    close() {
      this.open = false;
    },
  });
});

/**
 * @param {boolean} designMode
 */
window.VagueNewsletterPopup = function VagueNewsletterPopup(designMode) {
  return {
    designMode: Boolean(designMode),

    init() {
      this.$watch("$store.newsletter.open", (open) => {
        const dialog = this.$refs.dialog;
        if (!open && dialog?.open) dialog.close();
      });

      if (this.designMode) {
        this.$store.newsletter.show();
      }
    },

    dismiss() {
      this.$refs.dialog?.close();
    },

    onDialogClose() {
      this.$store.newsletter.close();
    },
  };
};
